import React from 'react'
import MobileSidebar from './mobile-sidebar'
import withPresentation from '../../with-presentation'

const MobileSidebarContainer = ({ presentationState, presentation }) => {
  const slide = presentation.slides[presentationState.activeSlideIndex]
  return (
    <MobileSidebar
      onCloseClick={presentationState.onClose}
      onBurgerClick={presentationState.toggleSidebar}
      onInfoClick={presentationState.toggleInfo}
      onCopy={presentationState.onCopy}
      infoOpened={presentationState.infoOpened}
      noNotes={!slide.public_note}
      opened={presentationState.sidebarOpened}
    />
  )
}

export default withPresentation(MobileSidebarContainer)
